<template lang="html">
  <component :is="tag" class="text">
    <slot></slot>
  </component>
</template>

<script>
export default {
  props: {
    tag: {
      type: String,
      default: 'p',
    },
  },
};
</script>

<style lang="scss">
.text {
  overflow-wrap: break-word;
  word-wrap: break-word;
  &.center {
    text-align: center;
  }
  &.title {
    font-weight: 300;
  }
}
</style>



// WEBPACK FOOTER //
// src/parts/components/text.vue